import './Layout.scss'

import React, { Component } from 'react'
import _ from 'lodash'

import MobileNav from 'broker/views/components/MobileNav/MobileNav'
import { logout } from 'common/redux/auth'
import { Tabs, Tab } from 'common/views/atoms/Tabs/Tabs'
import { isMobile, isRootActiveTab } from 'broker/util/helper'

import PageTitle from 'broker/views/components/PageTitle'

const DesktopNav = ({ tabs }) => (
  <nav className={'DashboardNav'}>
    <a href="/">
      <div className="Dashboard__logo"/>
    </a>
    <Tabs isActive={isRootActiveTab} value={location.pathname}>
      {_.map(tabs, (t, idx) => t.outboundLocation ? <Tab label={t.label} outboundLocation={t.outboundLocation} /> : <Tab label={t.label} value={t.value} key={idx} />)}
    </Tabs>
  </nav>
)

class Layout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: isMobile()
    }

    this.handleScreenSizeChange = _.debounce(() => {
      this.setState({
        isMobile: isMobile()
      })
    }, 50)
  }

  componentDidMount() {
    this.handleResize = window.addEventListener('resize', this.handleScreenSizeChange)
    this.handleOrientationChange = window.addEventListener('orientationchange', this.handleScreenSizeChange)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  }

  render() {
    const {dispatch, tabs, auth, children} = this.props

    function onLogout() {
      dispatch(logout())
    }

    var logoutLink = (<a onClick={onLogout}>Logout</a>)

    return (
      <div className="Dashboard">
        {this.state.isMobile ?
          <MobileNav links={tabs} /> :
          <DesktopNav tabs={tabs} />
        }
        {location.pathname !== '/terms' && location.pathname !== '/referral-fees' && <PageTitle/>}
        <div className="Dashboard__container">
          {children}
        </div>
        <footer>
          <div>
            &copy; Opcity, Inc. {new Date().getFullYear()} - Logged in as: {Object.keys(auth.user).length ? `${auth.user.username} - ` : ""}{auth.user.username ? logoutLink : ""}
          </div>
        </footer>
      </div>
    )
  }
}

export default Layout
